// sidebar nav links
import { ROLE } from '@/modules/User';

const { GUEST, LEARNER, TEACHER, SCHOOL, ADMIN } = ROLE;

export default {
  menu: [
    {
      menu_title: 'simulators',
      menu_icon: 'users',
      role: [LEARNER, TEACHER],
      path: '/simulators',
      child_routes: null,
    },
    {
      menu_title: 'reports',
      role: [LEARNER, TEACHER, SCHOOL, ADMIN],
      menu_icon: 'database',
      path: '/reports',
      child_routes: null,
    },
    {
      menu_title: 'HOMEWORK_TITLE',
      menu_icon: 'calendar-alt',
      role: [LEARNER, TEACHER, SCHOOL, ADMIN],
      path: '/homeworks',
      child_routes: null,
    },
    {
      menu_title: 'BOOK_TITLE',
      menu_icon: 'database',
      role: [TEACHER, SCHOOL, ADMIN],
      path: '/books',
      child_routes: null,
    },
    {
      menu_title: 'DIRECTORY',
      menu_icon: 'folder',
      role: [TEACHER, SCHOOL, ADMIN],
      child_routes: [
        {
          menu_title: 'SCHOOL_TITLE',
          path: '/directory/schools',
          role: [ADMIN],
        },
        {
          menu_title: 'TEACHER_TITLE',
          path: '/directory/teachers',
          role: [SCHOOL, ADMIN],
        },
        {
          menu_title: 'GROUP_TITLE',
          path: '/directory/groups',
          role: [TEACHER, SCHOOL, ADMIN],
        },
        {
          menu_title: 'STUDENT_TITLE',
          path: '/directory/students',
          role: [TEACHER, SCHOOL, ADMIN],
        },
      ],
    },
  ],
  user: [
    {
      menu_title: 'sidebar.settings',
      menu_icon: 'user',
      role: [GUEST, LEARNER, TEACHER, SCHOOL, ADMIN],
      child_routes: [
        {
          menu_title: 'sidebar.change_password',
          path: '/change-password',
          role: [LEARNER, TEACHER, SCHOOL, ADMIN],
        },
        {
          menu_title: 'sidebar.logout',
          path: '/logout',
          role: [GUEST, LEARNER, TEACHER, SCHOOL, ADMIN],
        },
      ],
    },
  ],
};
